import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

// SVG icons - source files in src/img/icons/
export const CloseTabIcon: React.FC<IconProps> = ({ className, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" className={className}>
    <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="currentColor"/>
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({ className, size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" className={className}>
    <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" className={className}>
    <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ClockOutlineIcon: React.FC<IconProps> = ({ className, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" className={className}>
    <path d="M8.667 0C6.953 0 5.277.508 3.852 1.461 2.427 2.413 1.316 3.766.66 5.35.004 6.934-.168 8.676.167 10.357c.334 1.682 1.16 3.226 2.371 4.438 1.212 1.212 2.756 2.037 4.438 2.372 1.681.334 3.424.163 5.007-.493 1.584-.656 2.937-1.767 3.889-3.192A8.655 8.655 0 0017.333 8.667C17.331 6.369 16.417 4.166 14.792 2.541 13.168.916 10.965.002 8.667 0zm0 16A7.333 7.333 0 118.667 1.333 7.333 7.333 0 018.667 16zM14 8.667a.667.667 0 01-.667.666H8.667A.667.667 0 018 8.667V4a.667.667 0 111.333 0v4h4A.667.667 0 0114 8.667z" fill="currentColor"/>
  </svg>
);

export const CheckmarkIcon: React.FC<IconProps> = ({ className, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" className={className}>
    <path d="M15 4.5L6.75 12.75L3 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ArchiveIcon: React.FC<IconProps> = ({ className, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" className={className}>
    <path d="M15.75 6V15c0 .414-.336.75-.75.75H3a.75.75 0 01-.75-.75V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.5 2.25H1.5a.75.75 0 00-.75.75v2.25c0 .414.336.75.75.75h15a.75.75 0 00.75-.75V3a.75.75 0 00-.75-.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 9h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MapIcon: React.FC<IconProps> = ({ className, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" className={className}>
    <path d="M1.5 4.5V15l4.5-2.25 6 3 4.5-2.25V3l-4.5 2.25-6-3L1.5 4.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 2.25v10.5M12 5.25v10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Icons below are picked in the admin panel for the cards of the "Полезное" section,
// see USEFUL_ICONS in components/SitePages/Useful/icons.tsx
export const DocumentIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Figma draws the sheet 14.4x17.6 centered in the 24x24 box, hence the offset */}
    <g transform="translate(4.8 3.2)">
      <path
        d="M14.2085 4.93646L9.62673 0.198C9.5659 0.135158 9.49369 0.0853275 9.41423 0.051354C9.33477 0.0173805 9.24962 -6.97135e-05 9.16364 2.09304e-07H1.30909C0.961898 2.09304e-07 0.628926 0.142637 0.383424 0.396533C0.137922 0.650428 0 0.994784 0 1.35385V16.2462C0 16.6052 0.137922 16.9496 0.383424 17.2035C0.628926 17.4574 0.961898 17.6 1.30909 17.6H13.0909C13.4381 17.6 13.7711 17.4574 14.0166 17.2035C14.2621 16.9496 14.4 16.6052 14.4 16.2462V5.41538C14.4001 5.32646 14.3832 5.2384 14.3503 5.15623C14.3175 5.07405 14.2693 4.99937 14.2085 4.93646ZM9.81818 2.31085L12.1655 4.73846H9.81818V2.31085ZM13.0909 16.2462H1.30909V1.35385H8.50909V5.41538C8.50909 5.59492 8.57805 5.76709 8.7008 5.89404C8.82355 6.02099 8.99004 6.09231 9.16364 6.09231H13.0909V16.2462ZM10.4727 9.47692C10.4727 9.65645 10.4038 9.82863 10.281 9.95558C10.1583 10.0825 9.99178 10.1538 9.81818 10.1538H4.58182C4.40822 10.1538 4.24174 10.0825 4.11898 9.95558C3.99623 9.82863 3.92727 9.65645 3.92727 9.47692C3.92727 9.29739 3.99623 9.12521 4.11898 8.99827C4.24174 8.87132 4.40822 8.8 4.58182 8.8H9.81818C9.99178 8.8 10.1583 8.87132 10.281 8.99827C10.4038 9.12521 10.4727 9.29739 10.4727 9.47692ZM10.4727 12.1846C10.4727 12.3641 10.4038 12.5363 10.281 12.6633C10.1583 12.7902 9.99178 12.8615 9.81818 12.8615H4.58182C4.40822 12.8615 4.24174 12.7902 4.11898 12.6633C3.99623 12.5363 3.92727 12.3641 3.92727 12.1846C3.92727 12.0051 3.99623 11.8329 4.11898 11.706C4.24174 11.579 4.40822 11.5077 4.58182 11.5077H9.81818C9.99178 11.5077 10.1583 11.579 10.281 11.706C10.4038 11.8329 10.4727 12.0051 10.4727 12.1846Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DownloadIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 3v12m0 0-4.5-4.5M12 15l4.5-4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TruckIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M1 3h15v13H1z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 8h4l3 3v5h-7V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="5.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="2"/>
    <circle cx="18.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const ShieldIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11.5l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CalculatorIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
    <rect x="7.5" y="5.5" width="9" height="3.5" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const BookIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2V3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7V3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ className, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" fill="currentColor"/>
  </svg>
);
